import { useController } from 'react-hook-form';
import Input from '../../../ui/Input';
import IsSkippable from './IsSkippable';
import { useContext } from 'react';
import { BountiesContext } from '../../../contexts/BountiesContext';
import Heading from '../../../ui/Heading';

const GetUserLocation = ({ register, index, errors, control, microtaskEditDetail }) => {
    const { isEdit } = useContext(BountiesContext);
    // const { field: skippableField } = useController({
    //     name: `microtasks.${index}.skippable`,
    //     control,
    // });
    return (
        <div>
            <div className="mb-2">
                <Heading type="microtaskTitle" className="capitalize text-textPrimary mb-1">
                    Title <sup className="text-lg relative top-[1px]">*</sup>
                </Heading>
                <Input
                    {...register(`microtasks.${index}.getLocation_Title`, {
                        required: 'Please enter a title',
                    })}
                    {...(isEdit && { defaultValue: microtaskEditDetail?.getLocation_Title || '' })}
                    error={errors?.microtasks && errors?.microtasks[index]?.getLocation_Title?.message}
                    placeholder={'Describe the microtask objective in 1 line'}
                    className={'w-[100%]'}
                />
            </div>
            <div className="mb-2">
                <Heading type="microtaskTitle" className="capitalize text-textPrimary mb-1">
                    Task Description <sup className="text-lg relative top-[1px]">*</sup>
                </Heading>
                <Input
                    {...register(`microtasks.${index}.getLocation_Subheading`, {
                        required: 'Please enter a description',
                    })}
                    {...(isEdit && { defaultValue: microtaskEditDetail?.getLocation_Subheading || '' })}
                    error={errors?.microtasks && errors?.microtasks[index]?.getLocation_Subheading?.message}
                    placeholder={'Describe the task'}
                    className={'w-[100%]'}
                />
            </div>

            {/* <div className="flex gap-9 my-2 items-center ">
                <IsSkippable
                    selectedOption={skippableField.value}
                    onSelectOption={(value) => {
                        skippableField.onChange(value);
                    }}
                    options={['Yes', 'No']}
                />
            </div> */}
        </div>
    );
};

export default GetUserLocation;
